import { auth } from './apiUrl';
import axios from 'axios';
import { request } from '../../../service/common';

//로그인
export const postLogin = async ({ loginId, password }) => {
  const { data } = await request.post(auth.login, { loginId, password });
  return data.datas;
};

export const postKakaoLogin = async ({ code, redirectUri }) => {
  const { data } = await request.post(auth.loginKakao, { code, redirectUri });
  return data.datas;
};
